<template>
  <div v-if="shape === 'card'" class="tw-flex tw-flex-wrap tw-gap-2">
    <div v-for="n in count" :key="n" class="tw-flex-1 tw-basis-56 tw-min-w-0">
      <Skeleton height="6.5rem" border-radius="6px" />
    </div>
  </div>

  <Skeleton v-else :height="height" border-radius="6px" />
</template>

<script>
import Skeleton from "primevue/skeleton";

export default {
  name: "PanelSkeleton",
  components: { Skeleton },
  props: {
    shape: { type: String, default: "panel" },
    count: { type: Number, default: 4 },
    height: { type: String, default: "22rem" },
  },
};
</script>
